import type { SVGProps } from 'react';

export const Flame = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="15" height="19" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.11301 8.5492C2.658 4.72014 5.04094 2.02703 9.50975 0.493347C6.77343 3.82635 11.8427 7.43674 12.1225 10.8974C12.7777 9.84806 13.1498 8.44794 13.2233 6.57523C16.5742 11.5094 13.7956 19.5741 6.42161 18.4147C5.74457 18.309 5.09254 18.1079 4.49837 17.8085C1.80895 16.4612 0.203125 13.5245 0.203125 10.7198C0.203125 8.93226 1.01777 7.33694 2.07164 6.0689C2.21237 7.31052 2.51258 8.2366 3.11301 8.5492Z"
        fill="#FF4B4B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.49502 14.0802C4.7351 12.2383 4.83987 9.2634 6.96794 8.21991C6.98358 11.6395 10.5721 12.0754 9.90754 15.7254C10.5205 15.0738 10.8301 14.0318 10.8848 13.2084C11.8574 15.2983 11.0943 16.97 9.70739 17.8212C5.49033 20.4101 1.85962 15.1618 4.27384 12.2853C4.34733 12.9281 5.18542 13.9202 5.49502 14.0802Z"
        fill="#FBC22F"
      />
    </svg>
  );
};
